/** @file Marks the Sample channels a compiled timeline keys (numeric bone, slot colour and IK channels). */
import { POSE_LAYOUT } from '../../contracts/pose';
import type { ChannelOffsets } from '../../contracts/sample';
import type { NumericBoneChannel, TimelineData } from '../../skeletonData';

const BONE: Record<NumericBoneChannel, number> = {
  x: POSE_LAYOUT.X, y: POSE_LAYOUT.Y, rotation: POSE_LAYOUT.ROTATION, scaleX: POSE_LAYOUT.SCALE_X,
  scaleY: POSE_LAYOUT.SCALE_Y, shearX: POSE_LAYOUT.SHEAR_X, shearY: POSE_LAYOUT.SHEAR_Y,
};
const SLOT = {
  rgb: [POSE_LAYOUT.SLOT_R, POSE_LAYOUT.SLOT_G, POSE_LAYOUT.SLOT_B],
  dark: [POSE_LAYOUT.SLOT_DARK_R, POSE_LAYOUT.SLOT_DARK_G, POSE_LAYOUT.SLOT_DARK_B],
  alpha: [POSE_LAYOUT.SLOT_ALPHA],
} as const;
const IK = {
  ikMix: POSE_LAYOUT.IK_MIX, ikSoftness: POSE_LAYOUT.IK_SOFTNESS, ikBend: POSE_LAYOUT.IK_BEND,
  ikStretch: POSE_LAYOUT.IK_STRETCH, ikCompress: POSE_LAYOUT.IK_COMPRESS,
} as const;

/** Sets mask[i] = 1 for every Sample.values channel tl writes; kinds with their own Sample arrays mark nothing. */
export function markKeyed(mask: Uint8Array, tl: TimelineData, layout: ChannelOffsets): void {
  switch (tl.k) {
    case 'rotation': case 'x': case 'y': case 'scaleX': case 'scaleY': case 'shearX': case 'shearY':
      mask[layout.boneStart + tl.bone * POSE_LAYOUT.LOCAL_STRIDE + BONE[tl.k]] = 1;
      return;
    case 'rgb': case 'dark': case 'alpha':
      for (const offset of SLOT[tl.k]) mask[layout.slotStart + tl.slot * POSE_LAYOUT.SLOT_STRIDE + offset] = 1;
      return;
    case 'ikMix': case 'ikSoftness': case 'ikBend': case 'ikStretch': case 'ikCompress':
      mask[layout.ikStart + tl.ik * POSE_LAYOUT.IK_STRIDE + IK[tl.k]] = 1;
      return;
    case 'inherit': case 'attachment': case 'deform': case 'drawOrder': case 'event':
      return;
  }
}
